import React from 'react'

import styledComp, { keyframes } from 'styled-components'
import { styled } from '@mui/material/styles'
import ButtonBase, { ButtonBaseProps } from '@mui/material/ButtonBase'
import Typography from '@mui/material/Typography'

import CircularProgress from '@mui/material/CircularProgress'

/* eslint-disable-next-line import/no-webpack-loader-syntax */
import ImageHammer from '!!file-loader!./hammer.png'
/* eslint-disable-next-line import/no-webpack-loader-syntax */
import ImageShield from '!!file-loader!./shield.png'
/* eslint-disable-next-line import/no-webpack-loader-syntax */
import ImageSword from '!!file-loader!./sword.png'

const SwordSwinging = keyframes`
  0% { transform: rotateZ(0deg); filter: drop-shadow(0 0 0 #900); }

  20% { transform: rotateZ(-60deg); filter: drop-shadow(0 0 3px #900); }

  60% { transform: rotateZ(-60deg); filter: drop-shadow(0 0 5px #900); }

  70% { transform: rotateZ(0deg); filter: drop-shadow(0 0 10px #900); }

  99% { filter: drop-shadow(0 0 200px #900); }
`
const HammerSwinging = keyframes`
  0% { transform: rotateZ(0deg); filter: drop-shadow(0 0 0 #339); }

  20% { transform: rotateZ(60deg); filter: drop-shadow(0 0 3px #339); }

  60% { transform: rotateZ(60deg); filter: drop-shadow(0 0 5px #339); }

  70% { transform: rotateZ(0deg); filter: drop-shadow(0 0 10px #339); }

  99% { filter: drop-shadow(0 0 200px #339); }
`

const Sword = styledComp.img.attrs({
  src: ImageSword,
})`
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 32;
  transform-origin: 20% 80%;

  &.swinging {
    animation: ${SwordSwinging} 1s;
  }
`
const Hammer = styledComp.img.attrs({
  src: ImageHammer,
})`
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 31;
  transform-origin: 80% 80%;

  &.swinging {
    animation: ${HammerSwinging} 1s;
  }
`
const Shield = styledComp.img.attrs({
  src: ImageShield,
})`
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 30;
`
const Button = styled(ButtonBase)((props: FightButtonProps) => ({
  position: 'relative',
  maxWidth: '100%',
  width: `${props.size ?? 130}px`,
  height: `${props.size ?? 130}px`,
  overflow: 'visible',
  borderRadius: '50%',
  transition: `all .2s ease-out`,

  '&.Mui-disabled': {
    filter: `grayscale(.8)`,
  },

  '&:hover, &:active, &:focus': {
    '.sword': {
      transform: `scale3d(1.08, 1.08, 1)`,
      filter: `drop-shadow(0 4px 3px rgba(0,0,0,.4))`,
      transition: `all .2s ease-out`,
    },
    '.hammer': {
      transform: `scale3d(1.04, 1.04, 1)`,
      filter: `drop-shadow(0 3px 3px rgba(0,0,0,.7))`,
      transition: `all .2s ease-out .15s`,
    },
    '.shield': {
      transform: `scale3d(1.02, 1.02, 1)`,
      filter: `drop-shadow(0 2px 3px black)`,
      transition: `all .2s ease-out .3s`,
    }
  },

  '&.choose-sword .sword': {
    animation: `${SwordSwinging.getName()} .6s ease-in`,
  },

  '&.choose-hammer .hammer': {
    animation: `${HammerSwinging.getName()} .6s ease-in`,
  },
}))

export type FightButtonStates = 'choose-sword' | 'choose-hammer' | null

interface FightButtonProps extends ButtonBaseProps {
  size: number
  state?: FightButtonStates
  fighting?: boolean
}
export default function FightButton({ state, fighting, size, children, ...props }: FightButtonProps) {
  return (
    <Button
      className={ state ? `fight-button ${state}` : 'fight-button' }
      size={size}
      {...props}
    >
      { fighting ? <CircularProgress size={size * .9} color="warning" /> : null }
      <Shield className="shield" />
      <Hammer className="hammer" />
      <Sword className="sword" />
      <Typography
        variant="FightButton"
        zIndex={40}
        position="absolute"
        bottom={8}
      >
        { children }
      </Typography>
    </Button>
  )
}
